import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PopupModule } from './components/popup/popup.module';
import { NavbarComponent } from 'src/app/register/components/navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { TrimValidatorDirective } from './directives/trim-validator.directive';
import { InterceptorModule } from './interceptor/interceptor.module';
import { TooltipModule } from 'ng2-tooltip-directive';
import { AuthenticationService } from './services/authentication.service';

@NgModule({
  declarations: [NavbarComponent, OnlyNumbersDirective, TrimValidatorDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    InterceptorModule.forRoot(),
    PopupModule,
    RouterModule,
    TooltipModule,
  ],
  exports: [
    NavbarComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    PopupModule,
    RouterModule,
    TooltipModule,
    OnlyNumbersDirective,
  ],
  providers: [AuthenticationService],
})
export class SharedModule {}
